module.exports = "/_next/static/images/eed6f823698ccc9fbc20a963797ee414-card-icon-new.svg";